import { render, staticRenderFns } from "./AscTermsAndConditionsWrapper.vue?vue&type=template&id=b44f2832&"
import script from "./AscTermsAndConditionsWrapper.vue?vue&type=script&lang=js&"
export * from "./AscTermsAndConditionsWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AscTermsAndConditionsWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports